import script from "./BeritaAcaraEvaluasiPenawaran.vue?vue&type=script&setup=true&lang=js"
export * from "./BeritaAcaraEvaluasiPenawaran.vue?vue&type=script&setup=true&lang=js"

import "./BeritaAcaraEvaluasiPenawaran.vue?vue&type=style&index=0&id=6acf36ea&scoped=true&lang=css"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6acf36ea"]])

export default __exports__